import React, { Fragment } from 'react';
import { FormattedMessage, useIntl } from 'react-intl/dist';
import ReactHtmlParser from 'react-html-parser';
import GenericHeader from '../../../components/common/pageHeader/GenericHeader';

const PreOEPLanding = ({ exchangeName, phone }) => {
    const intl = useIntl();

    return (
        <Fragment>
            <div className="grid-row gi-panel">
                <GenericHeader
                    id="welcome"
                    text="pre-oep_landing.header"
                    tag="h1"
                    headerClassName={['mobile:grid-col-12 tablet:grid-col-fill']}
                    textReplacements={{
                        exchangeName
                    }}
                />
                <p><strong>{ ReactHtmlParser(intl.formatMessage({ id: 'pre-oep_landing.para1' }, { exchangeName })) }</strong></p>
                <p><FormattedMessage id="pre-oep_landing.para2"  /></p>
                <p><strong><FormattedMessage id="pre-oep_landing.para3" values={{ exchangeName }}/></strong></p>
                <p>{ ReactHtmlParser(intl.formatMessage({ id: 'pre-oep_landing.para4' }, { phone })) }</p>
                <p>{ ReactHtmlParser(intl.formatMessage({ id: 'pre-oep_landing.para5' })) }</p>
            </div>
        </Fragment>
    );
};

export default PreOEPLanding;